<template>
    <div>
        <div v-for="langCode_e in p_questExplore_c.qex_langArr_ae" class="TQ_inline TQ_margin_8px TQ_verticalAlignTop">

            <div class="TQ_text_20px TQ_text_bold">
                {{format_langCode_fs(langCode_e)}}
            </div>

            <div v-if="p_questExplore_c.qex_introVideo_blc_c[langCode_e]" class="TQ_verticalAlignMiddle TQ_bg_hover_goldLite" >
                <div>
                    <video class="TQ_maxWidth_500px TQ_border TQ_borderRadius TQ_box_shadow TQ_height_250px"
                           controls :src="p_questExplore_c.qex_introVideo_blc_c[langCode_e].fi_url_s + '#t=0.0001'" ></video>
                </div>

                <div  class="TQ_padding_8px TQ_box_shadow TQ_borderRadius TQ_bg_gold  TQ_inline TQ_margin_16px TQ_clickable TQ_text_20px"
                      @click="() => {pe_chooseFile_f((videoFile_c) => {$set(p_questExplore_c.qex_introVideo_blc_c,langCode_e,videoFile_c)})}">
                    {{ass_strings.twoWords_changeVideo[langCode_e]}}
                </div>

                <div class="TQ_bg_red TQ_padding_8px TQ_borderRadius TQ_inline TQ_box_shadow TQ_text_20px TQ_clickable"
                     @click="() => {p_questExplore_c.qex_introVideo_blc_c[langCode_e] = null}">
                    {{ass_strings.oneWord_delete[langCode_e]}}
                </div>

            </div>

            <div v-else class="TQ_width_300px TQ_center TQ_border TQ_padding_72px TQ_box_shadow TQ_borderRadius TQ_clickable TQ_inline TQ_verticalAlignMiddle TQ_bg_hover_goldLite"
                 @click="() => {pe_chooseFile_f((videoFile_c) => {$set(p_questExplore_c.qex_introVideo_blc_c,langCode_e,videoFile_c)})}">
                <img :src="ass_img_videoPlayer" class="TQ_width_52px"/>
                <div>
                    {{ass_strings.sentence_clickToChooseIntoVideo[langCode_e]}}
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {FB_QuestExplore} from "../../../../../functions/src/shareCode/Share_S_Classes";
    import {ass_strings} from "../../../../../functions/src/shareCode/Share_Ass_Dictionary";
    import {format_langCode_fs} from "../../../../../functions/src/shareCode/Share_S_Format";
    import {ass_img_videoPlayer} from "@/assets/scripts/Ass_Files";

    export default {
        name: "c_Creator_EditQuests_Item_introVideo",
        props:{
            p_questExplore_c:{
                type: FB_QuestExplore,
                require: true
            },
            pe_chooseFile_f: {
                type: Function,
                require: true,
            },
        },
        data(){
            return {
                ass_strings : ass_strings,
                format_langCode_fs : format_langCode_fs,
                ass_img_videoPlayer : ass_img_videoPlayer,
            }
        }
    }
</script>

<style scoped>

</style>